<template>
  <div>
    <b-tabs v-model="tabIndex" v-on:activate-tab="tabActivated">
      <b-tab
        :title="`${this.$t('menu.settings.alertsNewsletters.titleGeneral')}`"
        active
      >
        <div v-if="loading" class="text-center text-primary my-2">
          <b-spinner type="grow" class="align-middle"></b-spinner>
        </div>
        <div v-else>
          <tab-geral-edit :editAlertRule="rule" />
        </div>
      </b-tab>
      <b-tab
        :title="`${this.$t('menu.settings.alertsNewsletters.titleBranch')}`"
      >
        <tab-branch-edit :rule="rule" :mainRuleId="rule._id" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import tabGeralEdit from './tab-geral-edit';
import tabBranchEdit from './tab-branch-edit';
import api from '../../../../../services/api';

export default {
  props: ['rule', 'ruleId'],

  components: {
    tabGeralEdit,
    tabBranchEdit,
  },

  computed: {
    ...mapFields('alertRules', ['myRule']),
  },

  data: () => ({
    tabIndex: 0,
    userAuth: null,
    loading: false,
  }),

  methods: {
    async tabActivated() {
      if (this.tabIndex === 0) {
        this.$store.state.settings.alertRulesFooter = false;
      } else {
        this.$store.state.settings.alertRulesFooter = true;
        this.loading = true;
        await this.getNewRule();
        this.loading = false;
      }
    },

    async getNewRule() {
      const response = await api.get(
        `${process.env.API_ROOT}/alert-rule/${this.userAuth.companyId}/${this.rule._id}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );
      this.myRule = response.data;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.$store.state.settings.alertRulesFooter = true;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/organisms/settings/settings-alert-rules/edit-rule/index.vue